import React, { useEffect, useContext } from "react";
import Footer from "../Components/Footer";
import firebase from "../firebase";
import wave from "../Assets/wave.svg";
import { AuthContext } from "../auth";
import { Dialog } from "../Components/DialogProvider";
import LifeDocLogoWhite from "../Assets/LifeDlogoWhite.png";
import DoctorBadge from "../Components/DoctorBadge";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: `url(${wave})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom",
    backgroundSize: "180%",
    height: "100vh",
    maxHeight: "100%",
    maxWidth: "100vw",
    overflow: "hidden",
  },
  postHeader: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
  },
  header: {
    margin: "auto",
    color: theme.palette.primary.main,
  },
  card: {
    margin: "auto",
    padding: theme.spacing(2),
    borderRadius: 12,
    maxWidth: 600,
    borderTop: `6px solid ${theme.palette.primary.main}`,
    boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
  },
}));
const Profile = (props) => {
  const classes = useStyles();
  const { currentUser } = useContext(AuthContext);
  const { handleOpenDialog, setProfileState } = useContext(Dialog);
  const [userProfile, setUserProfile] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const userRef = firebase.database().ref("users").child(currentUser.uid);

    userRef.on("value", (data) => {
      setUserProfile({ id: data.key, ...data.val() });
    });

    setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => {
      userRef.off();
    };
  }, []);

  const handleDialog = () => {
    setProfileState({ ...userProfile });
    handleOpenDialog("EDIT_PROFILE", "md");
  };

  const getInitials = (name) => {
    let parts = name.split(" ");
    let initials = "";
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].length > 0 && parts[i] !== "") {
        initials += parts[i][0];
      }
    }
    return initials;
  };

  return (
    <Container className={classes.root}>
      <Grid
        container
        spacing={0}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item lg={12}>
          <Typography component="div" className={classes.header}>
            <Box
              fontSize={40}
              display="block"
              fontWeight="fontWeightBold"
              lineHeight={1}
              p={1}
              textAlign="center"
            >
              My Profile
            </Box>
          </Typography>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                loading ? (
                  <Skeleton variant="circle" />
                ) : (
                  <Avatar alt={currentUser.displayName}>
                    {getInitials(currentUser.displayName)}
                  </Avatar>
                )
              }
              title={
                loading ? (
                  <Skeleton variant="text" />
                ) : (
                  <Typography component="div" color="textSecondary">
                    <Box fontSize={28} fontWeight="fontWeightBold">
                      {currentUser.displayName}
                      <DoctorBadge type="BIG" id={currentUser.uid} />
                    </Box>
                  </Typography>
                )
              }
              action={
                loading ? null : (
                  <Tooltip
                    title="Edit Profile"
                    enterDelay={300}
                    leaveDelay={200}
                    enterNextDelay={300}
                  >
                    <span>
                      <IconButton onClick={handleDialog}>
                        <EditRoundedIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                )
              }
            />
            <Divider variant="middle" />
            <CardContent>
              <Grid container spacing={2}>
                <Grid item lg={3}>
                  <Typography component="div">
                    <Box fontWeight="fontWeightBold" letterSpacing={0.4}>
                      First Name:
                    </Box>
                  </Typography>
                </Grid>
                <Grid item lg={9}>
                  {loading ? (
                    <Skeleton variant="text" />
                  ) : (
                    userProfile.firstName
                  )}
                </Grid>
                <Grid item lg={3}>
                  <Typography component="div">
                    <Box fontWeight="fontWeightBold" letterSpacing={0.4}>
                      Last Name:
                    </Box>
                  </Typography>
                </Grid>
                <Grid item lg={9}>
                  {loading ? <Skeleton variant="text" /> : userProfile.lastName}
                </Grid>
                <Grid item lg={3}>
                  <Typography component="div">
                    <Box fontWeight="fontWeightBold" letterSpacing={0.4}>
                      Email:
                    </Box>
                  </Typography>
                </Grid>
                <Grid item lg={9}>
                  {loading ? <Skeleton variant="text" /> : userProfile.email}
                </Grid>
                <Grid item lg={3}>
                  <Typography component="div">
                    <Box fontWeight="fontWeightBold" letterSpacing={0.4}>
                      Country:
                    </Box>
                  </Typography>
                </Grid>
                <Grid item lg={9}>
                  {loading ? <Skeleton variant="text" /> : userProfile.country}
                </Grid>
                <Grid item lg={3}>
                  <Typography component="div">
                    <Box fontWeight="fontWeightBold" letterSpacing={0.4}>
                      Mobile Number:
                    </Box>
                  </Typography>
                </Grid>
                <Grid item lg={9}>
                  {loading ? (
                    <Skeleton variant="text" />
                  ) : (
                    userProfile.phoneNumber
                  )}
                </Grid>
                {userProfile && userProfile.isVerified ? (
                  <>
                    <Grid item lg={3}>
                      <Typography component="div">
                        <Box fontWeight="fontWeightBold" letterSpacing={0.4}>
                          Specialty:
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item lg={9}>
                      {loading ? (
                        <Skeleton variant="text" />
                      ) : (
                        userProfile.specialty
                      )}
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={12}>
          <Footer logo={LifeDocLogoWhite} textColor="white" />
        </Grid>
      </Grid>
    </Container>
  );
};
export default Profile;
